import styles from "@/styles/login-layout.module.scss"
import React from "react"
import { useEffect } from "react"

import { loadMatomo } from "@/utils/matomo"
import { loadGtm } from "@/utils/gtm"

import Image from 'next/image'
import Link from 'next/link'
import getConfig from 'next/config'
import { useRouter } from 'next/router';
import { setCookie } from "@/utils/cookie"
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain
interface LayoutProps {
  children: React.ReactNode;
  wideScreen?: boolean;  // 是否使用宽屏
  notStickyNavbar?: boolean; // 是否取消Navbar吸顶效果
}

export default function LoginLayout(props: LayoutProps) {

  const router = useRouter()
  useEffect(() => {
    function handleWindowLoad() {
      loadMatomo()
      loadGtm();
    }

    window.addEventListener('load', handleWindowLoad);

    return () => {
      window.removeEventListener('load', handleWindowLoad);
    };
  }, []);

  useEffect(() => {
    const { aid, recoveraid }: any = router.query
    let lastAidValue = ''
    let lastRecoveraidValue = ''

    // 检查是否有"aid"参数，如有多个取最后
    if (Array.isArray(aid) && aid.length > 0) {
      lastAidValue = aid[aid.length - 1]
    } else if (typeof aid === 'string') {
      // 如果只有一个"aid"参数，它将是一个字符串
      lastAidValue = aid
    }

    // 检查是否有"recoveraid"参数，如有多个取最后
    if (Array.isArray(recoveraid) && recoveraid.length > 0) {
      lastRecoveraidValue = recoveraid[recoveraid.length - 1]
    } else if (typeof recoveraid === 'string') {
      // 如果只有一个"recoveraid"参数，它将是一个字符串
      lastRecoveraidValue = recoveraid
    }

    // 优先于异步请求，将aid存入cookie, 60秒过期（后续会发起请求重新设置）
    if (lastAidValue || lastRecoveraidValue) {
      let currentDomain = window.location.hostname;
      if (currentDomain == 'www.crazysales.com.au') {
        currentDomain = ".crazysales.com.au"
      }
      setCookie('affiliateid', lastAidValue || lastRecoveraidValue, { expires: 30, secure: true, domain: `${currentDomain}`, })
    }

  }, [router.query])

  return (
    <div className={styles['login-layout']}>
      <div className={styles['header']}>
        <Link
          href='/'
          legacyBehavior
        >
          <a rel="noopener noreferrer">
            <Image
              className={styles['site-logo']}
              alt="logo"
              priority={true}
              width={425}
              height={96}
              src={`${imageDomain}/logo.png`} />
          </a>
        </Link>
      </div>

      <main style={{ background: '#fff', minHeight: 'calc(100vh - 268px)', width: 1200, margin: '0 auto' }}>{props.children}</main>

      <div className={styles['footer']}>
        <Link
          href='/article/terms'
          legacyBehavior
        >
          <a className={styles['link']} rel="noopener noreferrer">
            Terms & Conditions
          </a>
        </Link>

        <div className={styles['separate']}></div>

        <Link
          href='/article/privacy'
          legacyBehavior
        >
          <a className={styles['link']} rel="noopener noreferrer">
            Privacy Statement
          </a>
        </Link>

        <div className={styles['separate']}></div>

        <Link
          href='/'
          legacyBehavior
        >
          <a className={styles['link']} rel="noopener noreferrer">
            <Image
              className={styles['site-logo']}
              alt="logo"
              priority={true}
              width={112}
              height={27}
              src="https://img.bestdeals.co.nz/images/easy-layout-Norton.png" />
          </a>
        </Link>

        <div className={styles['separate']}></div>

        <Link
          href='/'
          legacyBehavior
        >
          <Image
            className={styles['site-logo']}
            alt="logo"
            priority={true}
            width={88}
            height={47}
            src="https://img.bestdeals.co.nz/images/easy-layout-comodo.png" />
        </Link>
      </div>
    </div>
  )
}